import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { useLanguage } from '../../../../../contexts/LanguageContext';

/**
 * Final description dialog component for entering approval/rejection description
 */
const FinalyDescriptionDialog = ({ hideDialog, dialogVisible }) => {
    const { th } = useLanguage();
    const [description, setDescription] = useState('');
    
    const renderDialogFooter = () => {
        return (
            <div className="flex justify-content-end gap-2">
                <Button label={th('preApproval.finalyDescription.continueButton')} icon="pi pi-times" outlined onClick={hideDialog} type="button" />
            </div>
        );
    };

    return (
        <Dialog visible={dialogVisible} style={{ width: '40%' }} header={th('preApproval.finalyDescription.dialogHeader')} modal className="p-fluid" footer={renderDialogFooter()} onHide={hideDialog}>
            <div className="col-12 md:col-12">
                <label htmlFor="approvalNote" className="font-bold block mb-2">
                    {th('preApproval.form.approvalNoteLabel')}
                </label>
                <InputText 
                    id="approvalNote" 
                    value={description} 
                    onChange={(e) => setDescription(e.target.value)} 
                    placeholder={th('preApproval.form.placeholders.approvalNote')}
                />
            </div>
        </Dialog>
    );
};

export default FinalyDescriptionDialog;
